import React, { useState, useEffect, useRef } from 'react';

import { Modal, Tab, Tabs, Button } from 'react-bootstrap';

import Trash from "../../../../assets/images/trash.png";

const FormModal = ({ gridData, area, onRemove, onclose, onSubmit }) => {

    const [showModal, setShowModal] = useState(true);

    const handleRemove = (indexToRemove) => {
        onRemove(indexToRemove)
    };
    const handleModalClose = () => {
        onclose()
    }

    const handleConfirmChange = () => { onSubmit() }

    return (
        <>
            <Modal className='addfrom in_oparation' show={showModal} onHide={handleModalClose} centered>
                <Modal.Header closeButton>
                    {area === "AU" &&
                    <div>
                        <Modal.Title>Accept ULDs</Modal.Title>
                        <p>Do you want to accept selected ULDs?</p>
                    </div>
                    }
                    {area === "FF" &&
                    <div>
                        <Modal.Title>Finalize Flight - Flight No. / Flight Date</Modal.Title>
                        <p>All ULDs have been accepted, would you like to finalize flight and share UCM in with Airline</p>
                    </div>
                    }
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex flex-wrap inop opara_w'>
                        {gridData && gridData.map((num, index) => (

                            <div key={index} className='inbox'>
                                <span>{num.uld_number}</span>
                                <img src={Trash} alt='' onClick={() => handleRemove(num.uld_number)} />
                            </div>
                        ))}

                        {/* {selectedRowData && <div className='inbox'><span>{selectedRowData.uld_number}</span></div>} */}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {/* <Button variant="secondary" onClick={handleCancelChange}> */}
                    {/* {['Repair', 'Lease In', 'Lease Out', 'Condition'].includes(action) ? 'Cancel' : 'No'} */}
                    {/* </Button> */}
                    {area === 'AU' &&
                        <Button variant="primary" onClick={() => handleConfirmChange()}>
                            Accept ULS's
                        </Button>
                    }
                    {area === 'FF' &&
                        <div className="d-flex w-50 mx-auto are_bottom">
                            <Button variant="secondary" onClick={handleModalClose}> Cancel </Button>
                            <Button variant="primary" onClick={handleConfirmChange}> Finalize </Button>
                        </div>
                    }
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default FormModal